export default __webpack_public_path__ + "static/media/excavation5.c76d2f70.jpg";